export interface EcommerceEvent {
  event: string;
  step?: string;
  premium_calculator?: string;
  item_category?: string;
  purchase_type?: string;
  is_existing_customer?: boolean;
  ecommerce: {
    currency?: string;
    value?: number;
    transaction_id?: string;
    shipping_tier?: string;
    items: Item[];
  };
}

export interface Item {
  item_id: string;
  item_name: string;
  currency: string;
  index: number;
  item_category: string;
  item_category2: string;
  item_list_id: string;
  item_list_name: string;
  price: number;
  quantity: number;
  item_variant?: string;
  gender?: string;
  customer_type?: string;
  franchise?: string;
  accident_coverage?: string;
  insurance_provider?: string;
  purchase_type?: string;
  contract_length?: string;
}

export const ECOMMERCE_EVENT_TYPES = {
  VIEW_ITEM_LIST: 'view_item_list',
  SELECT_ITEM: 'select_item',
  VIEW_ITEM: 'view_item',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_CART: 'view_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  ADD_SHIPPING_INFO: 'add_shipping_info',
  CALCULATOR: 'calculator',
};
